import { createAction } from 'redux-act'

export const to = createAction()
export const toStory = createAction()
